import { CloseOutlined } from "@ant-design/icons";
import { Form, FormInstance, FormProps, Input, Modal, TreeSelect, Select, Switch } from "antd";
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from "react";
// import * as UnitApi from '../../../api/unit/unitApi';
import useToast from "../../../hook/useToast";
import './style.scss';
import { mixPostV2, mixGetV2 } from '../../../services/mixin'
import { json } from "stream/consumers";
import { editSystemParam, getListCustomerRecords } from "../../../api/paramCRM/paramCRMApi";
import useLoading from "../../../hook/useLoading";
import { fommatSelectOptionTitle } from "../../../until";
interface ModalProps {
  isOpen: boolean
  closeModal: () => void
  editData?: any
  modalFinish?: () => void

}
const ModalParamEditCRM: React.FC<ModalProps> = ({
  isOpen,
  editData,
  closeModal,
  modalFinish,
}) => {
  const [form] = useForm();
  const formRef = useRef<FormInstance>(null);
  const pushToast = useToast();
  const pushLoading = useLoading();


  const [dataOption, setDataOption] = useState<any[]>([])

  useEffect(() => {
    gListCustomerRecords()
  }, [])

  const submitForm = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  const gListCustomerRecords = async () => {
    const result = await getListCustomerRecords()
    if (result.status) {
      setDataOption(fommatSelectOptionTitle(result.data))
    }

  }


  const onFinish: FormProps["onFinish"] = async (values) => {
    const { category, name, code, status } = values
    pushLoading(true)
    const res = await editSystemParam(code, name, category, status ? 1 : 0)
    if (res.status) {
      pushToast("Thao tác thành công", "success")

      formRef?.current?.resetFields()
      if (modalFinish) {
        modalFinish()
      }
    } else {
      pushToast("Error!", "warning")
    }
    pushLoading(false)
  };

  useEffect(() => {
    formRef?.current?.setFieldsValue({
      name: editData.name,
      note: editData.note,
      code: editData.code,
      category: editData?.groups?.map((item: any) => item.id) || [],
      status: editData.is_active
    })
  }, [editData])




  const [tagInputAction, setTagInputAction] = useState(false)
  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">Param hệ thống</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal modal-content-creat-area ant-modal-size"
      closeIcon={false}
      footer={<div className="bg-FCFCFD d-flex justify-end align-center py-2 px-6 w-full border-t-F0F0F0 gap-2">
        <button className="text-sm text-344054 border-F2F4F7 bg-white h-8 px-15-px font-regular rounded-2 shadow-btn-save" onClick={closeModal}>Đóng</button>
        <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px font-regular shadow-btn-save"
          onClick={submitForm}>
          Lưu
        </button>
      </div>}
    >
      <Form
        form={form}
        ref={formRef}
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <div className="d-flex flex-column gap-18-px p-6">
          {/* <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Mã Param</p>
            <Form.Item
              name="column"
              rules={[{ required: true, message: 'Nhập mã Param!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                disabled
                placeholder="Mã Param"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div> */}
          {/* <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Mã</p>
            <Form.Item
              name='code'
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn mã'
                }
              ]}
            >
              <Select
                className='rs-select'
                placeholder='Chọn mã'
                showSearch
                allowClear
                filterOption={(input, option) => {
                  const normalize = (s: any) =>
                    String(s ?? '')
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .replace(/đ/g, 'd')
                      .replace(/Đ/g, 'D')
                      .toLowerCase()

                  const label = option?.label ?? option?.children ?? option?.value ?? ''
                  return normalize(label).includes(normalize(input))
                }}
                options={keyConfiguration ? keyConfiguration.map((val: any) => ({ label: val.value_key, value: val.name_key })) : []}
              />
            </Form.Item>
          </div> */}

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Mã</p>
            <Form.Item
              name="code"
              rules={[{ required: true, message: 'Nhập Mã!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Mã"
                disabled
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Tên Param</p>
            <Form.Item
              name="name"
              rules={[{ required: true, message: 'Nhập tên Param!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Tên Param"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Nhóm</p>
            <Form.Item
              name='category'
              className="m-none-form-item text-explan"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn nhóm'
                }
              ]}
            >
              <Select
                className='rs-select v2'
                placeholder='Chọn nhóm'
                mode='multiple'
                options={dataOption}
                showSearch={false}
              />
            </Form.Item>
          </div>
          <div className="d-flex  gap-1">
            <p className="text-sm  font-regular text-344054">Trạng thái</p>
            <Form.Item
              name='status'
              className="m-none-form-item text-explan"
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn nhóm'
                }
              ]}
            >
              <Switch />

            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  )
}
export default ModalParamEditCRM
